import {DI_TOKENS} from '@/di/di.tokens';
import {Assets, Spritesheet, Texture} from 'pixi.js';

import {injected} from 'brandi';

import {Config} from '@/types';

interface ClickerGameAssets {
  comet1: Texture;
  comet2: Texture;
  comet3: Texture;
  comet4: Texture;
  asteroid1: Spritesheet;
  asteroid2: Spritesheet;
  defaultParticle: Texture;
  spaceshipBronze: Texture;
  spaceshipSilver: Texture;
  spaceshipGold: Texture;
  spaceshipDiamond: Texture;
  starshipFlashlight: Texture;
  wave: Texture;
  bloomParticle: Texture;
  fire: Spritesheet;
  kotletkaHappy: Spritesheet;
  kotletkaClick: Spritesheet;
  kotletkaSadClick: Spritesheet;
  kotletkaIntensiveClick: Spritesheet;
  kotletkaSad: Spritesheet;
  kotletkaTransitionToSad: Spritesheet;
  kotletkaTransitionToHappy: Spritesheet;
  kotletkaCrystal: Spritesheet;
  kotletkaTransitionToSleepy: Spritesheet;
  kotletkaTransitionSleepyToHappy: Spritesheet;
  kotletkaSleepy: Spritesheet;
  kotletkaFireflies: Spritesheet;
  kotletkaShashlyk: Spritesheet;
  kotletkaDailyGame: Spritesheet;
  heart: Texture;
}

export class ClickerGameAssetsLoader {
  private readonly assetsConfig: Record<keyof ClickerGameAssets, string> = {
    comet1: this.getFullPath('clicker_сomet-1-2024-10-03-09-58-56.png'),
    comet2: this.getFullPath('clicker_сomet-2-2024-10-03-09-58-33.png'),
    comet3: this.getFullPath('clicker_сomet-3-2024-10-03-09-59-11.png'),
    comet4: this.getFullPath('clicker_сomet-4-2024-10-03-10-00-01.png'),
    asteroid1: this.getFullPath('asteroid-1-2024-10-07-08-54-27.json'),
    asteroid2: this.getFullPath('asteroid-2-2024-10-07-08-55-29.json'),
    defaultParticle: this.getFullPath('default-particle-2024-08-23-09-54-07.png'),
    spaceshipBronze: this.getFullPath('spaceship_bronze-2024-10-09-11-15-15.png'),
    spaceshipSilver: this.getFullPath('spaceship_silver-2024-10-09-11-15-31.png'),
    spaceshipGold: this.getFullPath('starship-gold-2024-10-07-14-46-48.png'),
    spaceshipDiamond: this.getFullPath('starship-diamond-2024-10-07-14-47-06.png'),
    wave: this.getFullPath('wave-2024-08-23-09-55-40.png'),
    bloomParticle: this.getFullPath('bloom-particle-2024-08-23-09-51-22.png'),
    fire: this.getFullPath('spaceship-fire-2024-10-07-14-14-18.json'),
    kotletkaHappy: this.getFullPath('kotletka-happy-2024-09-18-14-11-48.json'),
    kotletkaClick: this.getFullPath('kotletka_click-2024-10-17-07-41-48.json'),
    kotletkaSadClick: this.getFullPath('kotletka-sad-click-2024-09-16-13-05-39.json'),
    kotletkaIntensiveClick: this.getFullPath('kotletka-intensive-click-2024-09-18-14-44-09.json'),
    kotletkaSad: this.getFullPath('sad_kotletka-2024-11-25-14-19-29.json'),
    kotletkaTransitionToSad: this.getFullPath('kotletka-transition-to-sad-2024-09-16-13-06-13.json'),
    kotletkaTransitionToHappy: this.getFullPath('sad_to_happy-2024-11-25-14-19-50.json'),
    kotletkaCrystal: this.getFullPath('kotletka-crystal-2024-09-17-10-36-53.json'),
    kotletkaTransitionToSleepy: this.getFullPath('kotletka_idle-to-sleepy-2024-10-08-11-19-39.json'),
    kotletkaTransitionSleepyToHappy: this.getFullPath('kotletka_sleepy_to_idle-2024-10-17-07-47-46.json'),
    kotletkaSleepy: this.getFullPath('kotletka_sleepy-2024-10-08-11-19-06.json'),
    kotletkaFireflies: this.getFullPath('kotletka_fireflies-2024-10-08-13-42-55.json'),
    kotletkaShashlyk: this.getFullPath('shashlyk-2024-10-31-10-12-22.json'),
    starshipFlashlight: this.getFullPath('starship_star-2024-10-08-14-47-43.png'),
    kotletkaDailyGame: this.getFullPath('daily_game_completed-2024-11-01-07-20-24.json'),
    heart: this.getFullPath('heart-2024-12-04-14-18-39.png'),
  };
  public bundle: ClickerGameAssets;

  constructor(private readonly config: Config) {
    Assets.addBundle('main-bundle', this.assetsConfig);

    Assets.addBundle('fonts', {
      alias: 'Supermolot',
      src: `${this.config.staticUrl}/fonts/TT_Supermolot_Neue/woff/TT_Supermolot_Neue_Medium.woff`,
    });
    void Assets.loadBundle('fonts');
  }

  public async loadBundle(): Promise<ClickerGameAssets> {
    const bundle: ClickerGameAssets = await Assets.loadBundle('main-bundle');
    this.bundle = bundle;
    return bundle;
  }

  private getFullPath(relativePath: string): string {
    return `${this.config.cdnUrl}/static/invest24/${relativePath}`;
  }
}

injected(ClickerGameAssetsLoader, DI_TOKENS.config);
